import api from '@/services/Api'

// ----------------------------- o

const state = {
    errors: {},
    loading: false,
    navigation: [],
    settings: null
};

// ----------------------------- o

const getters = {

};

// ----------------------------- o

const actions = {
    'CONFIG_NAVIGATION_REQUEST': ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            commit('CONFIG_REQUEST');
            let url = 'config/navigation';
            api({url: url, method: 'GET'})
                .then(resp => {
                    commit('CONFIG_NAVIGATION_UPDATE', resp.data.data);
                    resolve(resp);
                })
                .catch(err => {
                    commit('CONFIG_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'CONFIG_SETTINGS_REQUEST': ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            commit('CONFIG_REQUEST');
            let url = 'config/settings';
            api({url: url, method: 'GET'})
                .then(resp => {
                    commit('CONFIG_SETTINGS_UPDATE', resp.data);
                    resolve(resp);
                })
                .catch(err => {
                    commit('CONFIG_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
};

// ----------------------------- o

const mutations = {
    'CONFIG_REQUEST': (state) => {
        state.errors = {};
        state.loading = true;
    },
    'CONFIG_NAVIGATION_UPDATE' : (state, resp) => {
        state.navigation = resp;
        state.loading = false;
    },
    'CONFIG_SETTINGS_UPDATE' : (state, resp) => {
        state.settings = resp;
        state.loading = false;
    },
    'CONFIG_ERROR': (state, resp) => {
        state.errors = resp;
        state.loading = false;
    },
};

// ----------------------------- o

export default {
    state,
    getters,
    actions,
    mutations,
}
